<template>
    <div class="my-step">
        <dl class="my-step__msg">
            <dt>初赛</dt>
            <template v-if="isBefore(preBegin)">
                <dd v-if="isBefore(preBegin - 86400000)">将于<span class="red">{{preBegin|time2text}}</span>开始</dd>
                <dd v-else>将于<span class="red">{{leftFor(preBegin)}}</span>后开始</dd>
            </template>
            <template v-else-if="isAfter(preEnd)">
                <dd v-if="finishCupNum > 0 && maxAvgScore > 0">你完成了<span class="red">{{finishCupNum}}</span>个初赛擂台，最高平均分<span class="red">{{maxAvgScore}}</span></dd>
                <dd v-else>已于<span class="red">{{preEnd|time2text}}</span>结束</dd>
            </template>
            <template v-else>
                <dd v-if="!isValidUser">初赛火热进行中，赶快登录参赛吧！</dd>
                <dd v-else-if="finishCupNum > 0 && maxAvgScore">
                    你完成了<span class="red">{{finishCupNum}}</span>个初赛擂台，最高分是<span class="red">{{maxAvgScore}}</span></dd>
                <dd v-else>初赛已开始，赶快去参加吧！</dd>
            </template>
        </dl>

        <div class="my-step__btn">
            <a v-if="nowTime >= preBegin" class="active" href="javascript:;" @click="goPrePlay">初赛大厅</a>
            <a v-else href="javascript:;">初赛大厅</a>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex'
    export default {
        name: 'my-step-pre',
        computed: {

            ...mapGetters(['nowTime', 'leftFor', 'isBefore', 'isAfter', 'signBegin', 'preBegin', 'preEnd', 'preRes',
                'finalBegin',
                'finalEnd',
                'finalRes',
                'isValidUser',
                'awardTime', 'finishCupNum', 'allCupNum',
                'isAdvance', 'isFinishFinal',
                'preRank', 'preScore', 'finalRank', 'finalScore', 'maxAvgScore'
            ]),
        },
        methods: {
            ...mapActions(['goPrePlay'])
        }
    };

</script>
